import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";

const useSubjectData = (handleDeleteClick, handleEditClick, refresh) => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Subject", align: "center" },
    { name: "Classes", align: "center" },
    { name: "action", align: "center" },
  ];

  useEffect(() => {
    axios
      .get(`${baseURL}/subjects`)
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          const activeSubjects = data.filter((subject) => !subject.isDeleted);
          setCount(activeSubjects.length);
          if (activeSubjects.length === 0) {
            setRows([]);
          } else {
            const formattedRows = activeSubjects.map((item, index) => ({
              sno: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {index + 1}
                </ArgonTypography>
              ),
              Subject: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {item.name}
                </ArgonTypography>
              ),
              Classes: (
                <ArgonBox display="flex" flexWrap="wrap" gap={0.5} justifyContent="center">
                  {item.classes && item.classes.length > 0 ? (
                    item.classes.map((cls, idx) => (
                      <ArgonTypography
                        key={idx}
                        variant="caption"
                        fontWeight="medium"
                        color="text"
                        sx={{
                          backgroundColor: "#f0f2f5",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          display: "inline-block",
                        }}
                      >
                        {typeof cls === "object" ? cls.name : cls}
                      </ArgonTypography>
                    ))
                  ) : (
                    <ArgonTypography variant="caption" fontWeight="medium" color="text">
                      N/A
                    </ArgonTypography>
                  )}
                </ArgonBox>
              ),
              action: (
                <ArgonBox display="flex" alignItems="center" gap={0}>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "12px", p: 0 }}
                    onClick={() => handleEditClick(item._id, item.name)}
                  >
                    <EditIcon color="warning" />
                  </ArgonButton>

                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "32px", p: 0 }}
                    onClick={() => handleDeleteClick(item._id)}
                  >
                    <DeleteIcon color="error" />
                  </ArgonButton>
                </ArgonBox>
              ),
            }));

            setRows(formattedRows);
          }
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching subjects:", err);
        const backendError = err.response?.data?.error;
        if (backendError) {
          toast.error(backendError);
        }
      });
  }, [refresh]);

  return { columns, rows, count };
};

export default useSubjectData;
